module.exports = __webpack_public_path__ + "img/paymet.e9c282e6.png";